import request from '../utils/Request';
import { Methods } from '../config';
import { downloadFile } from '../utils/download';
import dayjs from 'dayjs';

const baseURL = 'materialPlan';

const materialPlanService = {
  getItem: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getItemsFromView: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data/view`,
      data,
    });
  },

  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  getUnplannedDemand: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/unplannedDemand`,
      data,
    });
  },

  getExcelData: async (materialPlanId, planNo) => {
    const excelFromServer = await request({
      responseType: 'blob',
      resource: `${baseURL}/data/export/${encodeURIComponent(materialPlanId)}`,
    });

    return downloadFile(excelFromServer, `${planNo || 'anyagterv'}-${dayjs().format('YYYYMMDD_HHmm')}.xlsx`);
  },
};

export default materialPlanService;
